import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Logo } from "../../components/site/Seo";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setDone(true); }
    catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-ink flex items-center justify-center container-px hero-glow">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><Logo className="h-9" /></Link>
        <div className="card-surface p-7">
          <h1 className="font-heading text-xl font-bold mb-2">Reset your password</h1>
          {done ? (
            <p className="text-sm text-content-secondary">If that email is registered, a reset link has been sent. Check your inbox.</p>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <p className="text-sm text-content-secondary">Enter your email and we'll send you a reset link.</p>
              <Input type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-ink border-line h-11" data-testid="forgot-email" />
              <Button disabled={busy} className="btn-ember rounded-full w-full h-11" data-testid="forgot-submit">{busy ? "Sending…" : "Send reset link"}</Button>
            </form>
          )}
          <div className="text-center mt-5"><Link to="/login" className="text-xs text-content-muted hover:text-ember">Back to sign in</Link></div>
        </div>
      </div>
    </div>
  );
}
